module.exports = __webpack_public_path__ + "static/pic2-ff75e6479ed48076bf6e33aa87b84b22.jpg";